import { render } from "./CometChatBanGroupMemberListItem.vue?vue&type=template&id=9a6f806a"
import script from "./CometChatBanGroupMemberListItem.vue?vue&type=script&lang=js"
export * from "./CometChatBanGroupMemberListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__